/* ==========================================================================
   SERENA — shared behaviour
   Theme-agnostic: talks to Shopify's /cart AJAX API directly, so it does not
   depend on Dawn's (or any other theme's) cart JS being present.
   Every module is guarded, and re-initialises on Theme Editor section load.
   ========================================================================== */
(function () {
  'use strict';

  var $  = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  var CFG = window.SerenaConfig || {};
  var ROOT = CFG.routes || {};
  var money = function (cents) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return (CFG.currencySymbol || '$') + v;
  };

  /* --- toast ------------------------------------------------------------- */
  var toastEl, toastTimer;
  function toast(msg) {
    if (!msg) return;
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'sm-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-visible'); }, 2600);
  }
  window.serenaToast = toast;

  /* --- drawers ----------------------------------------------------------- */
  var lastFocus = null;

  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    var scrim = $('#serena-scrim');
    if (scrim) scrim.classList.add('is-open');
    document.body.classList.add('is-locked');
    var f = el.querySelector('button, a, input');
    if (f) f.focus();
  }

  function closeDrawers() {
    $$('.drawer').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    var scrim = $('#serena-scrim');
    if (scrim) scrim.classList.remove('is-open');
    document.body.classList.remove('is-locked');
    if (lastFocus) { try { lastFocus.focus(); } catch (e) {} lastFocus = null; }
  }
  window.serenaOpenDrawer = openDrawer;

  /* --- cart -------------------------------------------------------------- */
  function cartFetch() {
    return fetch((ROOT.cart || '/cart') + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function cartAdd(variantId, qty) {
    return fetch((ROOT.cartAdd || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || e.message); });
      return r.json();
    });
  }

  function cartChange(key, qty) {
    return fetch((ROOT.cartChange || '/cart/change') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count ? '' : 'none';
    });

    var body = $('#serena-cart-body');
    if (!body) return;

    var foot = $('#serena-cart-foot');
    var shipBar = $('#serena-ship-bar');

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="cart-empty"><p>' + (CFG.strings.cartEmpty || 'Your bag is empty.') + '</p>' +
        '<a class="sm-btn sm-btn--ghost" href="' + (ROOT.allProducts || '/collections/all') + '">' +
        (CFG.strings.cartEmptyCta || 'Continue shopping') + '</a></div>';
      if (foot) foot.hidden = true;
      if (shipBar) shipBar.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(function (l) {
      var img = l.image ? l.image.replace(/(\.[^.]*)$/, '_160x200_crop_center$1') : '';
      var opts = (l.options_with_values || []).map(function (o) { return o.value; }).join(' · ');
      return '' +
        '<div class="cart-line">' +
          (img ? '<img src="' + img + '" alt="" width="76" height="95" loading="lazy">' : '<span></span>') +
          '<div>' +
            '<h4><a href="' + l.url + '">' + l.product_title + '</a></h4>' +
            '<p>' + opts + '</p>' +
            '<div class="cart-line__foot">' +
              '<span class="qty">' +
                '<button type="button" data-cart-qty="' + l.key + '" data-to="' + (l.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
                '<span>' + l.quantity + '</span>' +
                '<button type="button" data-cart-qty="' + l.key + '" data-to="' + (l.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
              '</span>' +
              '<strong>' + money(l.final_line_price) + '</strong>' +
            '</div>' +
            '<button class="cart-line__remove" type="button" data-cart-qty="' + l.key + '" data-to="0">Remove</button>' +
          '</div>' +
        '</div>';
    }).join('');

    if (foot) {
      foot.hidden = false;
      var t = $('#serena-cart-total');
      if (t) t.textContent = money(cart.total_price);
    }

    if (shipBar && CFG.freeShipThreshold > 0) {
      shipBar.hidden = false;
      var left = CFG.freeShipThreshold - cart.total_price;
      var msg = $('#serena-ship-msg');
      if (msg) {
        var tpl = CFG.strings.shipAway || 'You are {{amount}} away from free shipping';
        msg.innerHTML = left > 0
          ? tpl.replace('{{amount}}', '<strong>' + money(left) + '</strong>')
          : '<strong>' + (CFG.strings.shipUnlocked || 'Free shipping unlocked.') + '</strong>';
      }
      var fill = $('#serena-ship-fill');
      if (fill) fill.style.width = Math.min(100, (cart.total_price / CFG.freeShipThreshold) * 100) + '%';
    }
  }

  function refreshCart(open) {
    return cartFetch().then(function (c) {
      renderCart(c);
      if (open) openDrawer($('#serena-cart-drawer'));
      return c;
    });
  }
  window.serenaRefreshCart = refreshCart;

  /* --- delegated clicks --------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest(
      '[data-serena-open],[data-serena-close],[data-quick],[data-variant-add],' +
      '[data-wish],[data-cart-qty],[data-modal],[data-modal-close],[data-rail]'
    );

    if (!t) {
      $$('.card__sizes.is-open').forEach(function (s) { s.classList.remove('is-open'); });
      return;
    }

    if (t.hasAttribute('data-serena-open'))  { e.preventDefault(); openDrawer($(t.getAttribute('data-serena-open'))); return; }
    if (t.hasAttribute('data-serena-close')) { closeDrawers(); return; }
    if (t.hasAttribute('data-modal'))        { e.preventDefault(); var m = $(t.getAttribute('data-modal')); if (m) m.classList.add('is-open'); return; }
    if (t.hasAttribute('data-modal-close'))  { t.closest('.sm-modal').classList.remove('is-open'); return; }

    if (t.hasAttribute('data-quick')) {
      e.preventDefault();
      var box = $('[data-sizes="' + t.getAttribute('data-quick') + '"]');
      if (!box) return;
      var wasOpen = box.classList.contains('is-open');
      $$('.card__sizes.is-open').forEach(function (s) { s.classList.remove('is-open'); });
      if (!wasOpen) box.classList.add('is-open');
      return;
    }

    if (t.hasAttribute('data-variant-add')) {
      e.preventDefault();
      if (t.disabled) return;
      var label = t.textContent.trim();
      t.disabled = true;
      cartAdd(t.getAttribute('data-variant-add'), 1)
        .then(function () {
          $$('.card__sizes.is-open').forEach(function (s) { s.classList.remove('is-open'); });
          toast((CFG.strings.added || 'Added to your bag') + (label ? ' — ' + label : ''));
          return refreshCart(true);
        })
        .catch(function (err) { toast(err.message || 'Sorry, that could not be added.'); })
        .then(function () { t.disabled = false; });
      return;
    }

    if (t.hasAttribute('data-cart-qty')) {
      var key = t.getAttribute('data-cart-qty');
      var to = parseInt(t.getAttribute('data-to'), 10);
      cartChange(key, Math.max(0, to)).then(renderCart);
      return;
    }

    if (t.hasAttribute('data-wish')) {
      t.classList.toggle('is-on');
      toast(t.classList.contains('is-on')
        ? (CFG.strings.wishAdd || 'Saved to your wishlist')
        : (CFG.strings.wishRemove || 'Removed from wishlist'));
      return;
    }

    if (t.hasAttribute('data-rail')) {
      var rail = $(t.getAttribute('data-rail'));
      if (!rail) return;
      var dir = t.getAttribute('data-dir') === 'prev' ? -1 : 1;
      rail.scrollBy({ left: dir * rail.clientWidth * 0.8, behavior: 'smooth' });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeDrawers();
      $$('.sm-modal.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    }
  });

  /* --- per-section initialisers (re-run on Theme Editor load) ------------- */
  function initScrim(scope) {
    var s = $('#serena-scrim', scope) || $('#serena-scrim');
    if (s && !s.dataset.bound) { s.dataset.bound = '1'; s.addEventListener('click', closeDrawers); }
  }

  function initAccordions(scope) {
    $$('[data-acc]', scope).forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        panel.classList.toggle('is-open', !open);
      });
    });
  }

  function initAnnounce(scope) {
    $$('[data-announce]', scope).forEach(function (bar) {
      if (bar.dataset.bound) return;
      bar.dataset.bound = '1';
      var items = $$('.announce__item', bar);
      if (items.length < 2) return;
      var i = 0, timer;
      var speed = parseInt(bar.getAttribute('data-speed'), 10) || 4600;
      function go(n) {
        items[i].classList.remove('is-active');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active');
      }
      function auto() { if (bar.getAttribute('data-autoplay') === 'true') timer = setInterval(function () { go(i + 1); }, speed); }
      auto();
      $$('.announce__nav', bar).forEach(function (b) {
        b.addEventListener('click', function () {
          clearInterval(timer);
          go(i + (b.classList.contains('announce__nav--prev') ? -1 : 1));
          auto();
        });
      });
    });
  }

  function initHeaderScroll(scope) {
    var header = $('[data-serena-header]', scope) || $('[data-serena-header]');
    if (!header || header.dataset.bound) return;
    header.dataset.bound = '1';
    var onScroll = function () { header.classList.toggle('is-stuck', window.scrollY > 12); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initTabs(scope) {
    $$('[data-occasion]', scope).forEach(function (mod) {
      if (mod.dataset.bound) return;
      mod.dataset.bound = '1';
      var tabs = $$('[data-occ-tab]', mod);
      var panels = $$('[data-occ-panel]', mod);
      var note = $('[data-occ-note]', mod);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-occ-tab');
          tabs.forEach(function (x) {
            var on = x === tab;
            x.classList.toggle('is-active', on);
            x.setAttribute('aria-selected', String(on));
          });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-occ-panel') !== id; });
          if (note) note.textContent = tab.getAttribute('data-note') || '';
        });
      });
    });
  }

  function initReveal(scope) {
    var els = $$('.reveal:not(.is-in)', scope);
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px 15% 0px' });
    els.forEach(function (el) { io.observe(el); });

    // safety net — nothing ever stays invisible (screenshots, print, no-scroll capture)
    function revealAll() { els.forEach(function (el) { el.classList.add('is-in'); }); }
    setTimeout(revealAll, 4000);
    window.addEventListener('beforeprint', revealAll);
  }

  function initAll(scope) {
    scope = scope || document;
    initScrim(scope);
    initAccordions(scope);
    initAnnounce(scope);
    initHeaderScroll(scope);
    initTabs(scope);
    initReveal(scope);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    refreshCart(false);
  });

  // Theme Editor: sections are re-rendered without a page reload
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:select', function (e) { initAll(e.target); });
})();